<template>
  <div>
    <div class="box">
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <h5 class="title is-5 has-text-centered pagination-list">
        <button class="button is-rounded is-white is-small" @click="getPrev()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="button is-rounded is-white is-small" @click="getNext()">
          <i class="fas fa-chevron-right"></i>
        </button>
        <span class="ml-3">{{ startDate }} ～ {{ endDate }}</span>
      </h5>
      <div class="mb-2 ml-4">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="showShortDeviceName"
            @click="changeshowShortDeviceName()"
          />
          {{ $t("dashboard.showShortDeviceName") }}
        </label>
      </div>
      <div class="table-container">
        <table
          class="table is-fullwidth table-container has-text-centered daily-report"
        >
          <thead>
            <tr>
              <th>{{ $t("devices.deviceId") }}</th>
              <th>{{ $t("devices.deviceLocate") }}</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>10</th>
              <th>11</th>
              <th>12</th>
              <th>13</th>
              <th>14</th>
              <th>15</th>
              <th>16</th>
              <th>17</th>
              <th>18</th>
              <th>19</th>
              <th>20</th>
              <th>21</th>
              <th>22</th>
              <th>23</th>
              <th>0</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in aggrList" v-bind:key="index">
              <td>
                <router-link
                  :to="{
                    name: 'dataView',
                    params: {
                      projectId: projectId,
                      deviceId: index,
                    },
                  }"
                >
                  {{ index }}
                </router-link>
              </td>
              <td class="has-text-left">
                <span
                  v-if="showShortDeviceName"
                  :data-tooltip="deviceList[index].name"
                >
                  {{ deviceList[index].shotName }}
                </span>
                <span v-else>
                  {{ deviceList[index].name }}
                </span>
              </td>
              <td v-for="(v, i) in item" v-bind:key="i" :class="v.color">
                {{ v.count }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import common from "@/imsr-common";
import { ref } from "vue";
import VueElementLoading from "vue-element-loading";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    VueElementLoading,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRoute();
    const store = useStore();
    const aggrList = ref();
    const isLoading = ref(false);
    const baseDate = ref(null);
    const startDate = ref();
    const endDate = ref();
    const nextDate = ref();
    const prevDate = ref();
    const deviceList = ref([]);
    const showShortDeviceName = ref(true);
    const getList = async () => {
      isLoading.value = true;
      try {
        const date = common.makeDate(baseDate.value);
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          startDate: date.start + "07",
          endDate: date.end + "06",
        };
        startDate.value = date.startStr;
        endDate.value = date.endStr;
        nextDate.value = date.nextDate;
        prevDate.value = date.prevDate;
        const res = await imsr.imsrGetApi("/events/hour", params);
        let data = {};
        res.years.forEach(function(years) {
          years.months.forEach(function(month) {
            month.days.forEach(function(days) {
              days.hours.forEach(function(hours) {
                hours.devices.forEach(function(device) {
                  if (!data[device.deviceId]) {
                    data[device.deviceId] = [];
                  }
                  let color = "";
                  if (device.count >= 5) {
                    color = "imsr-danger";
                    // color = "has-background-danger-light has-text-danger";
                  } else if (device.count > 0) {
                    color = "imsr-warning";
                    // color = "has-background-info-light has-text-info";
                  }
                  data[device.deviceId].push({
                    hour: hours.hour,
                    count: device.count,
                    color: color,
                  });
                });
              });
            });
          });
        });
        aggrList.value = data;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
      isLoading.value = false;
    };
    getList();

    const getDevice = async () => {
      try {
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
        };
        const res = await imsr.imsrGetApi("/devices/list", params);
        let data = [];
        res.forEach(function(val) {
          data[val.deviceId] = {
            name: val.deviceLocate,
            shotName: val.deviceLocate.substring(0, 6),
          };
        });
        deviceList.value = data;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getDevice();

    const loadshowShortDeviceName = () => {
      showShortDeviceName.value = store.getters.showShortDeviceName ?? true;
    };
    loadshowShortDeviceName();

    const getPrev = () => {
      baseDate.value = prevDate.value;
      getList();
    };

    const getNext = () => {
      baseDate.value = nextDate.value;
      getList();
    };

    const changeshowShortDeviceName = () => {
      showShortDeviceName.value = !showShortDeviceName.value;
      store.commit("setshowShortDeviceName", showShortDeviceName.value);
    };

    return {
      aggrList,
      isLoading,
      startDate,
      endDate,
      getPrev,
      getNext,
      deviceList,
      showShortDeviceName,
      changeshowShortDeviceName,
    };
  },
};
</script>
<style>
.has-event {
  padding: 0;
}
.daily-report {
  font-size: 90%;
}
.imsr-warning {
  background-color: rgb(255, 246, 97);
}
.imsr-danger {
  background-color: rgb(255, 137, 127);
}
</style>
